import { gql } from '@apollo/client';
import { OrganizationItem } from './organizationList';

export interface PendingHubspotDeal {
  id: string;
  dealId: string;
  dealName: string;
  createdAt: Date;
  updatedAt: Date;
  resolvedAt: Date;
  organizationId: string;
  organization: OrganizationItem;
}

export interface PendingHubspotDealsResponse {
  pendingHubspotDeals: PendingHubspotDeal[];
}

export const PENDING_HUBSPOT_DEALS = gql`
  query pendingHubspotDeals {
    pendingHubspotDeals {
      id
      dealId
      dealName
      createdAt
      updatedAt
      resolvedAt
      organizationId
      organization {
        id
        name
      }
    }
  }
`;
